import React, { Component } from 'react'
import { Section, Input, Checkbox } from '../../../../components'
import { STRING } from '../../../../helpers'
import NumberFormat from 'react-number-format'
export default class BidSubmission extends Component {
  render() {
    const {
      formData,
      editRoleDetail,
      isErrBIDDecrement,
      isErrBIDMinimum,
      isErrBID,
      isSetState,
    } = this.props
    return (
      <Section className={`form-group`}>
        <label className="bid-submission">Bid Submission</label>
        <Section className="form-group-control">
          <Section
            className="form-group-inner-wrapper"
            style={{ display: 'block' }}
          >
            <Section>
              <Checkbox
                id="decrement_bid"
                value="decrementBID"
                type="radio"
                name="eventBid"
                checked={!formData.step2.eventInformation.is_bid}
                onChange={e => {
                  formData.step2.eventInformation.is_bid = false
                  formData.step2.eventInformation.bid_minimum = ''
                  isSetState({
                    formData,
                    isErrBIDMinimum: false,
                  })
                }}
                disabled={!editRoleDetail ? true : false}
              >
                <label className="bid-submission">
                  Bid Decrement / Increment
                </label>
              </Checkbox>
              <Section
                className={`form-group ${isErrBIDDecrement && 'is-error'}`}
              >
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <NumberFormat
                      className="input-text-right"
                      value={
                        formData.step2.eventInformation.bid_decrement
                          ? formData.step2.eventInformation.bid_decrement
                          : ''
                      }
                      isAllowed={inputObj => {
                        const { value } = inputObj
                        if (value !== '-') return true
                        return false
                      }}
                      placeholder="0.00"
                      maxLength={18}
                      customInput={Input}
                      decimalScale={2}
                      onValueChange={e => {
                        if (e.floatValue <= 0) {
                          formData.step2.eventInformation.bid_decrement = null
                        } else {
                          formData.step2.eventInformation.bid_decrement =
                            e.floatValue
                        }
                        isSetState({
                          formData,
                          isErrBIDDecrement: false,
                        })
                      }}
                      thousandSeparator={true}
                      readOnly={
                        formData.step2.eventInformation.is_bid ||
                        !editRoleDetail
                          ? true
                          : false
                      }
                    />
                  </Section>
                  <Section className="message">
                    {isErrBIDDecrement && isErrBIDDecrement}
                  </Section>
                </Section>
              </Section>
            </Section>
            <Section>
              <Checkbox
                id="increment_bid"
                value="incrementBid"
                type="radio"
                name="eventBid"
                checked={formData.step2.eventInformation.is_bid}
                onChange={e => {
                  formData.step2.eventInformation.is_bid = true
                  formData.step2.eventInformation.bid_decrement = ''
                  isSetState({
                    formData,
                    isErrBIDDecrement: false,
                  })
                }}
                disabled={!editRoleDetail ? true : false}
              >
                <label className="bid-submission">
                  Minimum Bid <br />
                  Decrement / Increment
                </label>
              </Checkbox>
              <Section
                className={`form-group ${isErrBIDMinimum && 'is-error'}`}
              >
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <NumberFormat
                      className="input-text-right"
                      value={
                        formData.step2.eventInformation.bid_minimum
                          ? formData.step2.eventInformation.bid_minimum
                          : ''
                      }
                      isAllowed={inputObj => {
                        const { value } = inputObj
                        if (value !== '-') return true
                        return false
                      }}
                      placeholder="0.00"
                      maxLength={18}
                      customInput={Input}
                      decimalScale={2}
                      onValueChange={e => {
                        if (e.floatValue <= 0) {
                          formData.step2.eventInformation.bid_minimum = null
                        } else {
                          formData.step2.eventInformation.bid_minimum =
                            e.floatValue
                        }
                        isSetState({
                          formData,
                          isErrBIDMinimum: false,
                        })
                      }}
                      thousandSeparator={true}
                      readOnly={
                        !formData.step2.eventInformation.is_bid ||
                        !editRoleDetail
                          ? true
                          : false
                      }
                    />
                  </Section>
                  <Section className="message">
                    {isErrBIDMinimum && isErrBIDMinimum}
                  </Section>
                </Section>
              </Section>
            </Section>
          </Section>
          <Section className="message">{isErrBID && STRING.INVALID}</Section>
        </Section>
      </Section>
    )
  }
}
